import { Component } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'


const exampleHtml = `
<se-po-household-invite [profile]="profile" (invite)="hanldeInvite($event)">
</se-po-household-invite>
`

const exampleTypescript = `
import { Component, OnInit, ViewChild } from '@angular/core'
import { EditPersonaModalComponent } from '../../lib/edit-persona-modal/edit-persona-modal.component'
import { UserServiceResources as us } from 'se-resource-types'

export class EditPersonaModalChildExampleComponent {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]

  public email: cs.Profiles.EmailAddress
  public phone: cs.Profiles.PhoneNumber
}
`

const template = `<se-fe-docs-example [example]="this">${exampleHtml}</se-fe-docs-example>`

@Component({
  selector: 'se-po-household-invite-example',
  template,
  styleUrls: ['../household-invite-docs.component.scss'],
  standalone: false,
})
export class HouseholdInviteExampleComponent extends SeFeDocsExampleComponent {

  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]

  public profile = {
    firstName: 'John',
    lastName: 'Doe',
    dateOfBirth: '2023-10-01',
    gender: 'male',
    gradYear: '2099'
  }

  constructor() {
    super()
  }

  public hanldeInvite($event) {
    console.log($event)
  }
}
